import Dialog from "src/components/common/Dialog";
import Button from "src/components/core/Button";
import { Progress } from "src/components/shadcn/Progress";

interface FetchingSendCardInfoDialogProps {
  progress: { completed: number; total: number } | null;
  onCancel: () => void;
  cardCount: number;
}

const FetchingSendCardInfoDialog: React.FC<FetchingSendCardInfoDialogProps> = ({
  progress,
  onCancel,
  cardCount,
}) => {
  const value = progress
    ? Math.max(3, Math.round((progress.completed / progress.total) * 100))
    : 3;

  return (
    <Dialog
      isOpen={progress !== null}
      onOpenChange={(open) => !open && onCancel()}
      title="Preparing Cards"
      className="!max-w-sm"
    >
      <div className="p-6 flex flex-col items-center gap-4">
        <Progress value={value} className="w-full" />
        <p className="text-gray-700">Gathering information for {cardCount.toLocaleString()} {cardCount === 1 ? "card" : "cards"}...</p>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};

export default FetchingSendCardInfoDialog;
